import {
  DocsBeneficiary,
  DocsEvaluator,
  EvaluationIndex,
} from './components';

  export const tabs = (isDisabledTabs) => {
   return [
        {
          label: `2.1 Έγγραφα Δικαιούχου`,
          id: 0,
          Component: DocsBeneficiary,
          disabled: false,
        },
        // {
        //   label: `2.2 Έγγραφα Αξιολογητή`,
        //   id: 1,
        //   Component: DocsEvaluator,
        //   disabled: isDisabledTabs,
        // },
        // {
        //   label: `2.3 Δείκτης Αξιολόγησης`,
        //   id: 2,
        //   Component: EvaluationIndex,
        //   disabled: isDisabledTabs,
        // },
      ].filter(item => item);
  };
  